'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _spauiUtils = require('@tencent/spaui-utils');

var _info2 = require('./info');

var _info3 = _interopRequireDefault(_info2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * @fileOverview spaui switch
 * @author kirkzheng
 * @time 2017-12-27
 * @module @tencent/spaui-switch
 */

/**
 * @class
 */
var Switch = function (_PureComponent) {
    _inherits(Switch, _PureComponent);

    /**
     * 属性说明
     * @property {titleline} 全局属性
     * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
     * @property {titleline} 基础属性
     * @property {bool} checked=false 是否打开
     * @property {func} onChange 切换状态回调函数<br />onChange(event, checked)
     * @property {string} [size=''] 尺寸，size=default|large|extralarge
     * @property {bool} [disabled=false] 是否禁用
     */
    function Switch(props) {
        _classCallCheck(this, Switch);

        var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    _createClass(Switch, [{
        key: 'handleChange',
        value: function handleChange(event) {
            var _props = this.props,
                onChange = _props.onChange,
                checked = _props.checked;


            if ((0, _spauiUtils.isFunction)(onChange)) {
                onChange(event, !checked);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                checked = _props2.checked,
                disabled = _props2.disabled,
                onClick = _props2.onClick,
                size = _props2.size;


            return _react2.default.createElement(
                'label',
                _extends({}, (0, _spauiUtils.globalProps)(this.props, {
                    className: (0, _classnames2.default)('spaui-switch', {
                        'disabled': disabled,
                        'size-lg': size === 'large',
                        'size-xlg': size === 'extralarge'
                    })
                }, Switch), {
                    onClick: onClick
                }),
                _react2.default.createElement('input', {
                    type: 'checkbox',
                    className: 'spaui-switch-input',
                    checked: checked,
                    disabled: disabled,
                    onChange: this.handleChange
                }),
                _react2.default.createElement('span', { className: 'spaui-switch-helper' })
            );
        }
    }]);

    return Switch;
}(_react.PureComponent);

// 组件标记与上报


Switch.propTypes = {
    checked: _spauiUtils.PropTypes.bool.isRequired,
    onChange: _spauiUtils.PropTypes.func.isRequired,
    disabled: _spauiUtils.PropTypes.bool,
    size: _spauiUtils.PropTypes.string,
    onClick: _spauiUtils.PropTypes.func
};
Switch.defaultProps = {
    checked: false,
    disabled: false,
    szie: 'default'
};
(0, _spauiUtils.setComponentMark)(Switch, _info3.default, function () {
    (0, _spauiUtils.reportComponentUsage)(_extends({
        scope: 'spaui'
    }, _info3.default));
});

exports.default = Switch;